import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { EmptyStateTableComponent } from "./components/empty-state-table/empty-state-table.component";
import { LoadingStateTableComponent } from "./components/loading-state-table/loading-state-table.component";
import { LanguageSwitchComponent } from "./components/language-switch/language-switch.component";
import { TranslateModule } from "@ngx-translate/core";
import { PaginatePipe } from "./pipes/paginate/paginate.pipe";
import { EtzSearchPipe } from "./pipes/filter.pipe";
import { MatPaginatorModule } from "@angular/material/paginator";
import { NumberFormatPipe } from "./pipes/number-format.pipe";
import { SeminavComponent } from "./components/seminav/seminav.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { SearchableDropdownComponent } from "./components/searchable-dropdown/searchable-dropdown.component";
import { MultiSelectDropdownComponent } from "./components/multi-select-dropdown/multi-select-dropdown.component";
import { LinkifyPipe } from "./pipes/linkify.pipe";
import { NumberCommaDirective } from "./directives/number-comma.directive";
import { LoadingStateComponent } from "./components/loading-state/loading-state.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";

const COMPS: Array<any> = [
  EmptyStateTableComponent,
  LoadingStateTableComponent,
  LoadingStateComponent,
  LanguageSwitchComponent,
  SeminavComponent,
  PaginatePipe,
  EtzSearchPipe,
  NumberFormatPipe,
  SearchableDropdownComponent,
  MultiSelectDropdownComponent,
  LinkifyPipe,
];

@NgModule({
  declarations: [...COMPS, NumberCommaDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    // GooglePlaceModule,
    MatTooltipModule,
    MatInputModule,
    MatSelectModule,
    NgxChartsModule,
    MatExpansionModule,
    MatIconModule,
    TranslateModule.forChild(),
    MatPaginatorModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    ...COMPS,
    NumberCommaDirective,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    NgxChartsModule,
    // GooglePlaceModule,
    MatExpansionModule,
    TranslateModule,
    MatPaginatorModule,
    BsDatepickerModule,
  ],
  providers: [DatePipe],
})
export class SharedModule {}
